import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  hasText?: boolean;
}

const VariationWhiteRightUploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  hasText,
}) => {
  const settingsApplied =
    getWatermarkTag(image) !== 'none' ||
    Boolean(
      image.divider !== 'white' ||
        image.brakes ||
        !image.quotes ||
        image.fontSize,
    );

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings
      showText={false}
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages as any}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(VariationWhiteRightUploadedImageRow);
